import { getStorage, ref, uploadBytes, StorageReference } from "firebase/storage";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import { FirebaseError } from "firebase/app";
import firebaseErrors from "../../modules/firebaseErrors";
import Spinner from "react-bootstrap/Spinner";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";

const storage = getStorage();

export interface AddProps {
	folderPath: string;
	onAdded: (refs: StorageReference[]) => void;
}

export default function Create(props: AddProps) {
	const [adding, setAdding] = useState(false);
	const [error, setError] = useState<string>();

	const [showCreateDocument, setShowCreateDocument] = useState(false);

	const [files, setFiles] = useState<FileList>();

	useEffect(() => {
		if (!showCreateDocument) return;
		setError(undefined);
		setFiles(undefined);
	}, [showCreateDocument]);

	return (
		<div onClick={(event) => event.stopPropagation()}>
			<Card
				role="button"
				className="mb-2 clickable-card"
				onClick={() => setShowCreateDocument(true)}>
				<Card.Body>
					<Row>
						<Col xs="auto">
							<i className="bi bi-plus-circle fs-1" />
						</Col>
						<Col className="d-flex align-items-center">Dokumente hinzufügen</Col>
					</Row>
				</Card.Body>
			</Card>
			<Modal
				show={showCreateDocument}
				onHide={() => !adding && setShowCreateDocument(false)}
				backdrop="static"
				keyboard={false}>
				<Modal.Header closeButton>
					<Modal.Title>Dokumente hinzufügen</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Form.Group className="mb-2">
						<Form.Label>Dateien</Form.Label>
						<Form.Control
							multiple
							type="file"
							onChange={(e) => setFiles((e.target as HTMLInputElement).files || undefined)}
						/>
					</Form.Group>

					<div className="mb-2 text-muted">
						Tipp: Du kannst auch mehrere Dateien gleichzeitig auswählen und hochladen. Lade Word-
						oder Excel-Dateien als PDF hoch, damit diese durch den Dokumentenviewer angezeigt werden
						können.
					</div>

					{error && <div className="mb-2 text-danger">{error}</div>}
				</Modal.Body>
				<Modal.Footer>
					<Button
						disabled={!showCreateDocument || adding}
						variant="danger"
						onClick={() => {
							setShowCreateDocument(false);
						}}>
						Abbrechen
					</Button>
					<Button
						variant="success"
						disabled={!showCreateDocument || adding || !files || files.length <= 0}
						onClick={async () => {
							if (!files) return;

							const fileArray = Array.from(files);

							const baseRef = ref(storage, props.folderPath);

							setAdding(true);
							setError(undefined);

							try {
								const uploadResults = await Promise.all(
									fileArray.map(async (file) => {
										const arrayBuffer = await file.arrayBuffer();

										const fileRef = ref(baseRef, file.name);

										return await uploadBytes(fileRef, arrayBuffer, {
											contentType: file.type,
										});
									}),
								);

								setAdding(false);
								setShowCreateDocument(false);

								props.onAdded(uploadResults.map((result) => result.ref));
							} catch (error) {
								if (error instanceof FirebaseError) {
									setAdding(false);

									const message = firebaseErrors[error.code] ?? error.message;

									setError(message);
									return;
								}

								throw error;
							}
						}}>
						{adding && <Spinner className="me-1" animation="border" size="sm" />}
						Hinzufügen
					</Button>
				</Modal.Footer>
			</Modal>
		</div>
	);
}
